export class CreateBillingRule {

    billingRule;
    constructor(billingRule) {
      this.billingRule = billingRule;
    }
  };
  